import { useMutation, UseMutationResult } from '@tanstack/react-query';

import { parseApiError } from '@cast/api-client';
import { notify } from '@cast/design-system';
import { apiClient } from '@cast/infrastructure-api';
import { SecurityInsightsImageExceptionChangesRequest } from '@cast/types';

export const useChangeImageExceptionsMutation = (
  onSuccess: () => void
): UseMutationResult<
  unknown,
  unknown,
  SecurityInsightsImageExceptionChangesRequest,
  unknown
> => {
  return useMutation({
    mutationFn: (request) => {
      return apiClient.securityInsights.changeImageExceptions({
        body: request,
      });
    },
    onSuccess,
    onError: (error) => {
      notify.error(parseApiError(error));
    },
  });
};
